import { z } from 'zod/v4';
export var FileType;
(function (FileType) {
    FileType["pdf"] = "application/pdf";
    FileType["jpg"] = "image/jpeg";
    FileType["xls"] = "application/vnd.ms-excel";
    FileType["xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    FileType["doc"] = "application/msword";
    FileType["docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    FileType["png"] = "image/png";
    FileType["gif"] = "image/gif";
    FileType["txt"] = "text/plain";
    FileType["ppt"] = "application/vnd.ms-powerpoint";
    FileType["pptx"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    FileType["csv"] = "text/csv";
    FileType["rar"] = "application/x-rar-compressed";
    FileType["zip"] = "application/zip";
    FileType["jpeg"] = "image/jpeg";
    FileType["odt"] = "application/vnd.oasis.opendocument.text";
    FileType["rtf"] = "application/rtf";
})(FileType || (FileType = {}));
export const CreateFileSchema = z.object({
    content: z.string().base64(),
    contentType: z.string(),
    name: z.string().optional(),
});
export const FileSchema = z.object({
    fileName: z.string().nullish(),
    fileId: z.uuid(),
    contentType: z.string(),
});
export var CloudStorageFolders;
(function (CloudStorageFolders) {
    CloudStorageFolders["TRANSACTION_IMPORT"] = "transaction-imports";
})(CloudStorageFolders || (CloudStorageFolders = {}));
//# sourceMappingURL=index.js.map